import React from "react";
import PropTypes from "prop-types";
import { Icon } from "@qgiv/core-react";
import { ReceiptDetailHeading } from "@qgiv/core-donor";
import ConnectedReceiptParticipant from "./ConnectedReceiptParticipant";
import ConnectedReceiptSubtotal from "./ConnectedReceiptSubtotal";

const ReceiptDetailsParticipants = ({
    registrations = [],
    subtotal = 0.0,
    classificationLabel = "",
    controlId,
    participantsLabel,
    registrationSubtotalLabel,
    originalTotal = 0.0,
    showSubtotal,
}) => (
    <>
        {classificationLabel && (
            <div className="col col--12 col--no-top-gutter">
                <p>{classificationLabel}</p>
            </div>
        )}
        <div className="col col--12">
            <ReceiptDetailHeading>
                <Icon
                    className="-type--regular -font-weight--bold -margin-right--10"
                    glyph="user-solid"
                    type="FontAwesome"
                />
                <strong>
                    {participantsLabel} x {registrations.length}
                </strong>
            </ReceiptDetailHeading>
        </div>
        {registrations.map((registration) => {
            const { id } = registration;
            return (
                <ConnectedReceiptParticipant
                    key={id}
                    id={id}
                    controlId={controlId}
                />
            );
        })}
        {showSubtotal && (
            <div className="col col--12 col--no-top-gutter">
                <ConnectedReceiptSubtotal
                    total={subtotal}
                    subtotalLabel={registrationSubtotalLabel}
                    originalTotal={originalTotal}
                />
            </div>
        )}
    </>
);

ReceiptDetailsParticipants.propTypes = {
    registrations: PropTypes.arrayOf(PropTypes.shape({})),
    subtotal: PropTypes.number,
    classificationLabel: PropTypes.string,
    controlId: PropTypes.number.isRequired,
    participantsLabel: PropTypes.string.isRequired,
    registrationSubtotalLabel: PropTypes.string.isRequired,
    originalTotal: PropTypes.number,
    showSubtotal: PropTypes.bool.isRequired,
};

export default ReceiptDetailsParticipants;
